import { render, staticRenderFns } from "./Reciter.vue?vue&type=template&id=f198f922&"
import script from "./Reciter.vue?vue&type=script&lang=js&"
export * from "./Reciter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports